import { FreshAsphalt, SpbSky0 } from './palette';

export const bannerBg = SpbSky0;

export const bannerDotsActiveBg = FreshAsphalt;
export const bannerDotsBorder = FreshAsphalt;
